// NGRX
import {Action} from '@ngrx/store';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
// Models
import {Update} from '@ngrx/entity';
import {ProductGroupModel} from '../_models/product-group.model';

export enum ProductGroupActionTypes {
	ProductGroupOnServerCreated = '[Edit ProductGroup Component] ProductGroup On Server Created',
	ProductGroupCreated = '[Edit ProductGroup Component] ProductGroup Created',
	ProductGroupUpdated = '[Edit ProductGroup Component] ProductGroup Updated',
	ProductGroupsStatusUpdated = '[ProductGroups List Page] ProductGroups Status Updated',
	OneProductGroupDeleted = '[ProductGroups List Page] One ProductGroup Deleted',
	ManyProductGroupsDeleted = '[ProductGroups List Page] Many Selected ProductGroups Deleted',
	ProductGroupsPageRequested = '[ProductGroups List Page] ProductGroups Page Requested',
	ProductGroupsPageLoaded = '[ProductGroups API] ProductGroups Page Loaded',
	ProductGroupsPageCancelled = '[ProductGroups API] ProductGroups Page Cancelled',
	ProductGroupsPageToggleLoading = '[ProductGroups] ProductGroups Page Toggle Loading',
	ProductGroupsActionToggleLoading = '[ProductGroups] ProductGroups Action Toggle Loading'
}

export class ProductGroupOnServerCreated implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupOnServerCreated;

	constructor(public payload: { productGroup: ProductGroupModel }) {
	}
}

export class ProductGroupCreated implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupCreated;

	constructor(public payload: { productGroup: ProductGroupModel }) {
	}
}

export class ProductGroupUpdated implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupUpdated;

	constructor(public payload: {
		partialProductGroup: Update<ProductGroupModel>, // For State update
		productGroup: ProductGroupModel // For Server update (through service)
	}) {
	}
}

export class ProductGroupsStatusUpdated implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupsStatusUpdated;

	constructor(public payload: {
		productGroups: ProductGroupModel[],
		status: number
	}) {
	}
}

export class OneProductGroupDeleted implements Action {
	readonly type = ProductGroupActionTypes.OneProductGroupDeleted;

	constructor(public payload: { id: number }) {
	}
}

export class ManyProductGroupsDeleted implements Action {
	readonly type = ProductGroupActionTypes.ManyProductGroupsDeleted;

	constructor(public payload: { ids: number[] }) {
	}
}

export class ProductGroupsPageRequested implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupsPageRequested;

	constructor(public payload: { page: QueryParamsModel }) {
	}
}

export class ProductGroupsPageLoaded implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupsPageLoaded;

	constructor(public payload: { productGroups: ProductGroupModel[], totalCount: number, page: QueryParamsModel }) {
	}
}

export class ProductGroupsPageCancelled implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupsPageCancelled;
}

export class ProductGroupsPageToggleLoading implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupsPageToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export class ProductGroupsActionToggleLoading implements Action {
	readonly type = ProductGroupActionTypes.ProductGroupsActionToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export type ProductGroupActions = ProductGroupOnServerCreated
	| ProductGroupCreated
	| ProductGroupUpdated
	| ProductGroupsStatusUpdated
	| OneProductGroupDeleted
	| ManyProductGroupsDeleted
	| ProductGroupsPageRequested
	| ProductGroupsPageLoaded
	| ProductGroupsPageCancelled
	| ProductGroupsPageToggleLoading
	| ProductGroupsActionToggleLoading;
